import { gql } from '@apollo/client'

export default gql(`
    mutation updateVirtualSeasonEpisodes($input: [SeriesAssetPositionUpdateInput] $assetId: String $project: String $module: String) {
        updateVirtualSeasonEpisodes(
            input: $input
            assetId: $assetId
            project: $project
            module : $module
        ) {
            id
            assetId
            isArchived
            shortId
            externalId
            title
            type
            updatedAt
            publishStartDate
            publishEndDate
            status
            isFree
            position
            episodeNumber
            series{
                id
                assetId
                title
            }
            season{
                id
                assetId
                title
            }
            defaultMedia {
                id
                url
                fileName
                aspectRatio {
                    title
                    aspectRatio
                    resolutions {
                    url
                    }
                }
                settings {
                    aspectRatio
                    outputFormat
                    fileName
                    x1
                    y1
                    x2 
                    y2
                }
            }
        }
    }`
)
